import CardSystem from '../CardSystem';
import { ICardsState } from '../../../State/Card/ICardState';
import BaseCardHandler from './BaseCardHandler';
import RockCard from 'Prototype/Level/Card/RockCard';
import { Anim, StartAnimationClip } from 'System/Animation/AnimationHelper';
import TextComponent from 'Component/Render/Text';
import { createSelector, OutputSelector, SelectorArray } from 'reselect';
import CardStateHelper from 'State/Card/CardStateHelper';
import { CardModifierType } from 'Prototype/Level/Card/CardModifierType';
import { DragonbonesDefault } from 'System/Animation/Clip';

export default class RockCardHandler extends BaseCardHandler {
    public pickaxeCountSelector: OutputSelector<
        [(state: ICardsState) => void],
        void,
        (inPlayPickaxeCardCount: number) => void
    > = createSelector(
        (cardsState: ICardsState) =>
            CardStateHelper.getCardsInPlay(cardsState, {
                requireCardModifierTypes: [CardModifierType.pickaxe],
            }).length,
        (inPlayPickaxeCardCount: number) => {
            const prevCount = this.displayedCount;

            this.updatePickaxesAmountText(inPlayPickaxeCardCount);

            if (prevCount === this.displayedCount) return;

            Anim(this.pickaxesAmountText, { scaleX: 1.2, scaleY: 1.2, duration: 200, yoyo: true, delay: 200 });

            StartAnimationClip(
                new DragonbonesDefault(this.card.getArmature(), {
                    animationName: 'countdown',
                    playTimes: 1,
                })
            );
        }
    );

    public handleCardDiscarded(state: ICardsState, cardSystem: CardSystem): void {
        this.updatePickaxesAmountText(0);
        Anim(this.pickaxesAmountText, { alpha: 0, duration: 300 });
    }

    public handleCardInPlay(state: ICardsState, cardSystem: CardSystem): void {
        this.pickaxeCountSelector(state);
    }

    public updatePickaxesAmountText(amount: number): void {
        this.pickaxesAmountText.getComponent(TextComponent).text = `${amount}`;
    }

    public get pickaxesAmountText(): GameObject {
        return this.card.findChildByName(RockCard.PICKAXE_COUNT_TEXT_NAME);
    }

    public get displayedCount(): string {
        return this.pickaxesAmountText?.getComponent(TextComponent)?.text;
    }
}
